import { useMemo } from 'react';
import { TABS } from '../constants/tabs';
const parentRenderedFeatures = [TABS.APPROVALS];
export function useIsTabParentRendered(tab) {
  return useMemo(() => {
    return parentRenderedFeatures.includes(tab);
  }, [tab]);
}